import { defineStore } from 'pinia'
import { removeMerchantId } from '@/utils/auth-merchant'
import apiMerchant from '@/api/merchant'
import DiscountPriceMode from '@/const/merchant/DiscountPriceMode'
import CutOffTime from '@/const/merchant/CutOffTime'
import dayjs from 'dayjs'
import OpenWineCardSaveRemainingVolumeUnit from '@/const/confiscation/OpenWineCardSaveRemainingVolumeUnit'
import OpenWineCardSaveRemainVolumeField from '@/const/confiscation/OpenWineCardSaveRemainVolumeField'

export const useMerchantStore = defineStore('merchant', {
  state: () => ({
    id: '', // 商户id
    name: '',
    merchantInfo: null, // 商户信息
    isOpenWineCardSaveWriteRemainingVolume: false, // 开瓶存酒填写剩余容量
    openWineCardSaveRemainingVolumeUnit: OpenWineCardSaveRemainingVolumeUnit.UNIT_CM, // 开瓶存酒剩余容量单位
    openWineCardSaveRemainingVolumeField: OpenWineCardSaveRemainVolumeField.FIELD_CM // 开瓶存酒剩余容量字段
  }),
  getters: {
    /**
     * 是否开启会员价
     * @param state
     * @returns {boolean}
     */
    isOpenMemberPrice: (state) => {
      return state.merchantInfo?.discount_price_mode !== DiscountPriceMode.DISCOUNT_PRICE_MODE_NO
    },

    cutOffTime: (state) => {
      return state.merchantInfo?.cut_off_time || CutOffTime.TIME_8_TO_8
    },

    /**
     * 日切时间小时
     * @returns {number}
     */
    cutOffTimeHour() {
      if (!this.cutOffTime) {
        return 8
      }
      return parseFloat(this.cutOffTime.slice(0, 2))
    },

    /**
     * 获取当前日期，日切时间前算昨天
     * @returns {string}
     */
    todayDateStr() {
      const now = dayjs()
      const curDate = now.format('YYYY-MM-DD')
      const cutOffMoment = dayjs(`${curDate} ${this.cutOffTime}`)
      if (now.isBefore(cutOffMoment)) {
        return now.subtract(1, 'days').format('YYYY-MM-DD')
      }
      return curDate
    }
  },

  actions: {
    /**
     * 设置 MerchantId
     * @param commit
     * @param data
     */
    async getMerchantInfo() {
      const { data } = await apiMerchant.getMerchantDetail()
      this.id = data.id
      this.merchantInfo = data
      this.isOpenWineCardSaveWriteRemainingVolume =
        data.is_open_wine_card_save_write_remaining_volume
      this.openWineCardSaveRemainingVolumeUnit = data.open_wine_card_save_unit
      const openWineCardSaveRemainingVolumeField =
        OpenWineCardSaveRemainingVolumeUnit.map.get(data.open_wine_card_save_unit)?.field ||
        OpenWineCardSaveRemainVolumeField.FIELD_CM
      this.openWineCardSaveRemainingVolumeField = openWineCardSaveRemainingVolumeField
    },

    /**
     * 清除商户信息
     * @param commit
     */
    clearMerchantInfo() {
      removeMerchantId()

      // 将state的值还原成默认值
      this.$reset()
    },

    setMerchantField(field, value) {
      if (field) {
        this[field] = value
      }
    }
  }
})
